import { User } from '@vsolv/core/users/domain';

export const ESCALATION_TEXT_MAX_LENGTH = 1000;

/** Flags a job for someone's attention. It never blocks or changes the job's decision. */
export interface Model {
  id: string;

  claimId: string;
  claimItemId: string;

  reason: string;

  /** Staff user id of whoever should look at it. */
  ownerId: string;
  /** The owner's name when the job was escalated. */
  ownerName: string;

  resolvedAt: Date | null;
  resolvedById: string | null;
  resolvedBy?: User.Model | null;
  resolutionNote: string | null;

  created: Date;
  createdById: string | null;
  createdBy?: User.Model | null;
}

export interface EscalateRequest {
  reason: string;
  ownerId: string;
}

export interface ResolveEscalationRequest {
  note?: string | null;
}

export interface EscalationResponse {
  id: string;
}

export interface ListEscalationsResponse {
  items: Model[];
}
